export const Pin = ({ className }: { className: string }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_11327_137)">
        <path
          d="M19.2004 11.342C19.3444 5.84598 14.9284 1.38198 9.45636 1.45398C4.2004 1.52598 -0.0475972 5.86998 0.00040281 11.126C0.0244028 14.894 2.2324 18.134 5.4004 19.694C5.5924 19.79 5.8084 19.646 5.7844 19.43C5.7604 18.806 5.7844 18.158 5.9044 17.63C6.0244 17.102 6.5044 15.086 6.8164 13.766C6.9604 13.118 6.9844 12.446 6.8644 11.798C6.8164 11.582 6.7924 11.342 6.7924 11.054C6.7924 9.63801 7.60836 8.58198 8.64036 8.58198C9.50436 8.58198 9.93636 9.23001 9.93636 10.022C9.93636 10.886 9.38436 12.206 9.09636 13.43C8.85636 14.438 9.60036 15.278 10.6084 15.278C12.4324 15.278 13.8244 13.358 13.8244 10.598C13.8244 8.14998 12.0724 6.44598 9.55236 6.44598C6.6484 6.44598 4.9444 8.62998 4.9444 10.886C4.9444 11.774 5.2804 12.71 5.7124 13.214C5.7844 13.31 5.8084 13.406 5.7844 13.502C5.7124 13.814 5.5444 14.51 5.4964 14.654C5.4484 14.846 5.3524 14.87 5.1604 14.798C3.8884 14.174 3.0724 12.302 3.0724 10.814C3.0724 7.59798 5.4004 4.64598 9.81636 4.64598C13.3444 4.64598 16.1044 7.16598 16.1044 10.55C16.1044 14.078 13.8964 16.886 10.8004 16.886C9.98436 16.886 9.21636 16.55 8.76036 16.094C8.61636 15.95 8.37636 16.022 8.32836 16.214C8.16036 16.814 7.92036 17.822 7.82436 18.134C7.68036 18.71 7.3684 19.382 7.0324 19.982C6.9364 20.126 7.0324 20.342 7.2004 20.366C7.99236 20.558 8.80836 20.678 9.64836 20.654C14.7364 20.606 19.0564 16.382 19.2004 11.342Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11327_137">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.453125)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
